/* eslint-disable import/no-cycle */
import ApprovalInsertTransaction from '../views/insert-transaction-on-us/ApprovalInsertTransaction.vue';
import ApprovalInsertTransactionDetail  from '../views/insert-transaction-on-us/ApprovalInsertTransactionDetail.vue';
import HistoryInsertTransaction from '../views/insert-transaction-on-us/HistoryInsertTransaction.vue';
import HistoryInsertTransactionDetail from '../views/insert-transaction-on-us/HistoryInsertTransactionDetail.vue';
import insertTransaction from '../views/insert-transaction-on-us/InsertTransaction.vue';
import Parent from '../views/Parent.vue';
import { setBreadcrumb } from './index';

const insertTransactionOnUsRoute = {
  path: '/insert-transaction-on-us',
  name: 'Insert Transaction On Us',
  meta: {
    title: 'BNI QRIS - Insert Transaction On Us',
    appBarTitle: 'Insert Transaction On Us',
  },
  component: Parent,
  children: [
    {
      path: '/insert-transaction-on-us/request-insert-transaction',
      meta: {
        title: 'BNI QRIS - Request Insert Transaction On Us',
        appBarTitle: 'Request Insert Transaction On Us',
        breadcrumbs: () => [
          setBreadcrumb('Insert Transaction On Us', '/insert-transaction-on-us', true),
          setBreadcrumb(
            'Request Insert Transaction On Us',
            '/insert-transaction-on-us/request-insert-transaction'
          ),
        ],
      },
      component: insertTransaction,
      name: 'Request Insert Transaction On Us',
    },
    {
      path: '/insert-transaction-on-us/approval-insert-transaction',
      meta: {
        title: 'BNI QRIS - Approval Insert Transaction On Us',
        appBarTitle: 'Approval Insert Transaction On Us',
        breadcrumbs: () => [
          setBreadcrumb('Insert Transaction On Us', '/insert-transaction-on-us', true),
          setBreadcrumb(
            'Approval Insert Transaction On Us',
            '/insert-transaction-on-us/approval-insert-transaction'
          ),
        ],
      },
      component: ApprovalInsertTransaction,
      name: 'Approval Insert Transaction On Us',
    },
    {
      path: '/insert-transaction-on-us/approval-insert-transaction/detail/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Detail Approval Insert Transaction On Us',
        appBarTitle: 'Detail Approval Insert Transaction On Us',
        breadcrumbs: (params) => {
          const { id } = params;

          return [
            setBreadcrumb('Refund Internal', '/insert-transaction-on-us', true),
            setBreadcrumb('Approval Insert Transaction On Us', '/insert-transaction-on-us/approval-insert-transaction'),
            setBreadcrumb('Detail Approval Insert Transaction On Us', '/insert-transaction-on-us/approval-insert-transaction/detail', true),
            setBreadcrumb(`${id}`, `/insert-transaction-on-us/approval-insert-transaction/detail/${id}`),
          ];
        },
      },
      component: ApprovalInsertTransactionDetail,
      name: 'Detail Approval Insert Transaction On Us',
    },
    {
      path: '/insert-transaction-on-us/history-insert-transaction',
      meta: {
        title: 'BNI QRIS - History Insert Transaction On Us',
        appBarTitle: 'History Insert Transaction On Us',
        breadcrumbs: () => [
          setBreadcrumb('Insert Transaction On Us', '/insert-transaction-on-us', true),
          setBreadcrumb(
            'History Insert Transaction On Us',
            '/insert-transaction-on-us/history-insert-transaction'
          ),
        ],
      },
      component: HistoryInsertTransaction,
      name: 'History Insert Transaction On Us',
    },
    {
      path: '/insert-transaction-on-us/history-insert-transaction/detail/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Detail History Insert Transaction On Us',
        appBarTitle: 'Detail History Insert Transaction On Us',
        breadcrumbs: (params) => {
          const { id } = params;

          return [
            setBreadcrumb('Refund Internal', '/insert-transaction-on-us', true),
            setBreadcrumb('History Insert Transaction On Us', '/insert-transaction-on-us/history-insert-transaction'),
            setBreadcrumb('Detail History Insert Transaction On Us', '/insert-transaction-on-us/history-insert-transaction/detail', true),
            setBreadcrumb(`${id}`, `/insert-transaction-on-us/history-insert-transaction/detail/${id}`),
          ];
        },
      },
      component: HistoryInsertTransactionDetail,
      name: 'Detail History Insert Transaction On Us',
    },
  ],
};

export default insertTransactionOnUsRoute;
